export function SecondaryButton({text, onClick, ...rest}) {
    return (
        <button
        type="button"
        className="mr-2 inline-flex w-full justify-center items-center rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-200 sm:mt-0 sm:w-auto"
        onClick={onClick}
        {...rest}
      >
        {text}
      </button>
    )
}